(ns storrito.connect3.change-password-panel
  (:require [storrito.ui.button :as button]
            [storrito.connect3.common :as common]
            [clojure.string :as str]
            ))

(def min-password-length
  "Instagram rejects new passwords shorter than 6 characters."
  6)

(defn get-password-validation-error
  "Returns a validation error for the new password, or nil when it is ok."
  [password]
  (let [password (str password)]
    (cond
      (str/blank? password)
      "Please enter a new password"

      (< (count password) min-password-length)
      (str "The new password must be at least "
           min-password-length
           " characters long"))))

(defn panel
  "Instagram's change-password checkpoint: the login is blocked until a new
   password is set. connect.php waits for a reply with the \"new-password\"
   key (handleExceptions.php, ChangePasswordException case)."
  [state]
  (let [new-password (:new-password state)
        validation-error (get-password-validation-error new-password)
        send-action [[:connect3/send! {:new-password new-password}]]]
    [:div.flex.items-center.justify-center
     [:div.bg-white.shadow-xl.rounded-2xl.px-8.pt-10.pb-10.max-w-xl.w-full.mx-auto.flex.flex-col.items-center
      (common/instagram-logo)
      [:div.text-center.mb-5
       [:h2.font-bold.text-xl.text-center
        "Instagram requires a new password"]]
      [:p.text-gray-700.mb-6.text-center.w-full
       "Instagram flagged this login for security reasons and only continues
        after a new password is set. Pick one below — it replaces your
        current Instagram password, so remember it for future logins."]
      [:div.flex.flex-col.justify-center.items-center.w-full
       ;; Wrapper div for password-manager compatibility, see comment in
       ;; `storrito.connect3.login-panel/panel`.
       [:div.w-full
        [:input#new-password.w-full.px-5.py-3.placeholder-gray-500.border-gray-400.rounded-md.border-2.bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-blue-500.focus:border-blue-500.transition-all.duration-200.mb-2
         {:name "new-password"
          :type "password"
          :required true
          :autoComplete "new-password"
          :placeholder "New Instagram password"
          :autoFocus true
          :on {:input [[:store/assoc-in [:connect3 :new-password] :event/target.value]]
               :keyup (when-not validation-error
                        (into [[:js/on-enter]] send-action))}}]]
       (when (and (seq (str new-password))
                  validation-error)
         [:p.text-sm.text-red-500.w-full.text-left.mb-2
          validation-error])
       (common/error-message state)
       (button/button-primary-lg
         {:class "w-full mt-4"
          :on {:click (when-not validation-error
                        send-action)}}
         "Set new password")]]]))
